import _filterInstanceProperty from '@babel/runtime-corejs3/core-js/instance/filter';
import _JSON$stringify from '@babel/runtime-corejs3/core-js/json/stringify';
import _reverseInstanceProperty from '@babel/runtime-corejs3/core-js/instance/reverse';
import _sliceInstanceProperty from '@babel/runtime-corejs3/core-js/instance/slice';
import _includesInstanceProperty from '@babel/runtime-corejs3/core-js/instance/includes';
import _spliceInstanceProperty from '@babel/runtime-corejs3/core-js/instance/splice';
import _indexOfInstanceProperty from '@babel/runtime-corejs3/core-js/instance/index-of';
import { uniq } from 'lodash';

var STORAGE_KEY = 'search-histories';
var HISTORY_KEY = 'header-search-history';
var getSearchHistoryFromLocalStorage = function getSearchHistoryFromLocalStorage() {
  var storage = localStorage.getItem(STORAGE_KEY) || '{}';
  var storageValue;

  try {
    storageValue = JSON.parse(storage) || {};
  } catch (error) {
    return [];
  }

  return storageValue[HISTORY_KEY] || [];
};
var setSearchHistoryToLocalStorage = function setSearchHistoryToLocalStorage(data) {
  var storage = localStorage.getItem(STORAGE_KEY) || '{}';
  var storageValue;

  try {
    storageValue = JSON.parse(storage) || {};
  } catch (error) {
    return;
  }

  storageValue[HISTORY_KEY] = uniq(_filterInstanceProperty(data).call(data, function (d) {
    return d.length;
  }));
  localStorage.setItem(STORAGE_KEY, _JSON$stringify(storageValue));
};
var getLatestKeywords = function getLatestKeywords(list) {
  var _context;

  var keywordList = list || getSearchHistoryFromLocalStorage();
  var maxLength = 10; // 历史记录最多 10 条，slice 传参负数，倒序截取最新 10 条

  return _reverseInstanceProperty(_context = _sliceInstanceProperty(keywordList).call(keywordList, -maxLength)).call(_context);
};
var saveKeyword = function saveKeyword(keyword) {
  if (!keyword) return;
  var histories = getSearchHistoryFromLocalStorage();

  if (_includesInstanceProperty(histories).call(histories, keyword)) {
    _spliceInstanceProperty(histories).call(histories, _indexOfInstanceProperty(histories).call(histories, keyword), 1);
  }

  histories.push(keyword);
  setSearchHistoryToLocalStorage(histories);
};

export { HISTORY_KEY, STORAGE_KEY, getLatestKeywords, getSearchHistoryFromLocalStorage, saveKeyword, setSearchHistoryToLocalStorage };
